// @ts-nocheck
import { useState, useEffect } from "react";
import { initializeDeviceId } from "../../services/indexDb";

export const useDeviceId = () => {
  const [deviceId, setDeviceId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    initializeDeviceId()
      .then((id) => {
        if (mounted) {
          setDeviceId(id);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (mounted) {
          console.error("Failed to initialize device ID:", err);
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { deviceId, loading, error };
};